import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { TokenService } from '../services/token.service';
import { v4 as uuidv4 } from 'uuid';
import { LanguageService } from '../../Shared/services/language.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const languageService = inject(LanguageService);
  const accessToken = tokenService.getaccessToken();
  const correlationId = uuidv4();
  sessionStorage.setItem('correlationId', correlationId);

  const cloned = req.clone({
    setHeaders: {
      Authorization: `Bearer ${accessToken}`,
      'X-Correlation-Id': correlationId,
      'accept-language': languageService.resolveLang() || 'en',
    },
  });

  return next(cloned);

  // if (!azureKeys) {
  //   return timer(2000).pipe(
  //     switchMap(() => {
  //       const cloned = req.clone({
  //         setHeaders: {
  //           Authorization: `Bearer ${accessToken}`,
  //           'X-Correlation-Id': correlationId,
  //         },
  //       });

  //       return next(cloned);
  //     })
  //   );
  // } else {

  // }
};
